export default {
	   // baseURL: 'http://127.0.0.1:8999/nssb/',
	// test
	baseURL: 'https://test_nssb.taxunion.com.cn/nssb/',
	// baseURL: 'http://192.168.31.173:8999/nssb/',
	// baseURL:'http://test.nssb.taxunion.com.cn:8888/nssb/',
	// baseURL:'http://hls.nssb.taxunion.com.cn:8999/nssb/',
	// baseURL:'https://tax.beta.junglead.vip/tax/',
	//baseURL:'http://192.168.2.30:8234/pp/',
	sassURL: 'http://test.nssb.taxunion.com.cn:8082/saas/',
	eiURL: 'https://fapiaoforceuat.taxunion.net/ei/',
	//hls,shm
	company: "",
	homePage: "0", // 1 新版驾驶舱  其他值或空值  默认首页
	lsbqyEnable: true, // 底稿生成、申报缴款页面是否显示 仅展示零申报企业条件
}